const sorting = [
    {
        label: "Abjad A-Z",
        name: "sorting",
        value: JSON.stringify({
            sortBy: "abjad",
            orderBy: "ASC",
        }),
        id: "sorting-1",
    },
    {
        label: "Abjad Z-A",
        name: "sorting",
        value: JSON.stringify({
            sortBy: "abjad",
            orderBy: "DESC",
        }),
        id: "sorting-2",
    },
    {
        label: "Settlement terbaru",
        name: "sorting",
        value: JSON.stringify({
            sortBy: "waktu_settlement",
            orderBy: "DESC",
        }),
        id: "sorting-3",
    },
    {
        label: "Settlement terlama",
        name: "sorting",
        value: JSON.stringify({
            sortBy: "waktu_settlement",
            orderBy: "ASC",
        }),
        id: "sorting-4",
    },
    {
        label: "Saldo terbanyak",
        name: "sorting",
        value: JSON.stringify({
            sortBy: "saldo",
            orderBy: "DESC",
        }),
        id: "sorting-5",
    },
    {
        label: "Saldo terendah",
        name: "sorting",
        value: JSON.stringify({
            sortBy: "saldo",
            orderBy: "ASC",
        }),
        id: "sorting-6",
    },
];

export default sorting